import styled from 'styled-components';

interface IGeoDialogListItemProps{
    itemPrefix:string;
    isLast?:boolean;
}

export const GeoDialogListItemBox = styled.div<IGeoDialogListItemProps>`
    position: relative;
    margin-bottom: ${({isLast}) => isLast?'0px':'20px'};
    font-size: 1.5rem;
    text-align:left;
    &:before{
        content:${({itemPrefix}) => '"'+itemPrefix+'"'};
        color: ${({theme}) => theme.colors.textActive};
        position:absolute;
        top:-1px;
        left:-40px;
        width:25px;
        height:25px;
        border:1px solid ${({theme}) => theme.colors.textActive};
        border-radius: 50%;
        display: block;
        text-align: center;
        background: #0a0a0a;
    }
`;